













































































































































































































































import { Component, Mixins, Prop } from 'vue-property-decorator'
import Daterange from '@/mixins/daterange'
import BrandPicker from './BrandPicker.vue'
import * as api from '@/service/step-five'
import { State } from 'vuex-class'

@Component({
  components: { BrandPicker },
})
export default class BrandInfo extends Mixins(Daterange) {
  @Prop({ required: true }) data!: { brand_list: any[] }
  @Prop({ default: () => [] }) catList!: any[]
  @State bidType!: number;

  trademark_types = ['TM商标', 'R商标']
  columns = [
    {
      title: '序号',
      key: 'index',
      width: 80,
      customRender: (text: any, record: any, index: number) => index + 1,
    },
    {
      title: '品牌资质',
      dataIndex: 'brand_type',
      customRender: (value: 1 | 2 | 3) => ['自有品牌', '代理品牌', '白牌'][value - 1],
    },
    {
      title: '商标名称类型',
      dataIndex: 'brand_name_type',
      customRender: (value: 0 | 1, row: any) => row.brand_type == 3 ? '--' : ['中文名称', '英文名称'][value],
    },
    {
      title: '商标名称',
      dataIndex: 'brand_name',
      customRender: (value: any, row: any) => row.brand_type == 3 ? '--' : value,
    },
    {
      title: '商标类型',
      dataIndex: 'trademark_type',
      customRender: (value: any, row: any) => row.brand_type == 3 ? '--' : value,
    },
    {
      title: '商标号',
      dataIndex: 'trademark_number',
      customRender: (value: any, row: any) => row.brand_type == 3 ? '--' : value,
    },
    {
      title: '操作',
      key: 'action',
      scopedSlots: { customRender: 'action' },
    },
  ]
  dialogVisible = false
  form: any = {}
  loading = false
  delBrandId = ''
  beforeLevel = ''
  get isTM() {
    return this.form.trademark_type === this.trademark_types[0]
  }

  get dictionary() {
    return {
      trademark_number: this.isTM ? '商标申请号' : '商标注册号',
      trademark_date: this.isTM ? '商标申请日期' : '商标注册日期',
      trademark_url:this.isTM
          ? '商标受理通知书照片'
          : '商标注册证照片',
    }
  }

  get rules() {
    return {
      agent_level: [{ required: true, message: '请选择代理商级别' }],
      trade_owner: [{ required: true, message: '商标注册人全称' }],
      brand_name: [{ required: true, message: '请填写商标名称' }],
      trademark_type: [{ required: true, message: '请选择商标类型' }],
      trademark_number: [{ required: true, message: '请填写商标号' }],
      trademark_date: [
        {
          required: true,
          message: '请选择' + this.dictionary.trademark_date,
        },
      ],
      trademark_end_date: [
        {
          required: true,
          message: '请选择商标有效期',
        },
      ],
      authorize_end_date: [
        {
          required: true,
          message: '请选择品牌授权截止日期',
        },
      ],
      first_agent_name: [{ required: true, message: '一级代理方名称' }],
      second_auth_end_date: [
        {
          required: true,
          message: '请二级授权截止日期',
        },
      ],
      second_auth_url: [
        {
          required: true,
          message: '请上传二级销售授权书照片' ,
        },
      ],

      trademark_url: [
        {
          required: true,
          message: '请上传' + this.dictionary.trademark_url,
        },
      ],
      brand_authorize_url: [
        {
          required: true,
          message: '请上传品牌销售授权书' ,
        },
      ],
      relate_cat_ids: [
        {
          required: true,
          message: '请选择关联经营类目',
        },
      ],
    }
  }

  validate() {
    return (this.$refs.form as any).validate()
  }

  getPopupContainer(node: Element) {
    return node.parentNode
  }

  addBrand() {
    if (this.bidType == 8) {
      this.form = {
        brand_type: 3,
      }
    } else {
      this.form = {
        brand_type: 1,
        brand_name_type: 0,
        trademark_type: this.trademark_types[1],
      }
    }
    this.dialogVisible = true
  }

  view(item: any) {
    //兼容之前数据
    this.beforeLevel = item.agent_level
    this.form = { ...item, brand_id: item.id } // 编辑时需要传brand_id
    this.dialogVisible = true
  }

  async handleDelete(item: any) {
    this.delBrandId = item.id
    try {
      await api.delBrand(item.id)
      const list = this.data.brand_list
      list.splice(list.indexOf(item), 1)
    } catch {}
    this.delBrandId = ''
  }

  afterClose() {
    (this.$refs.modalForm as any).clearValidate()
  }

  onBrandTypeChange(e: any) {
    // if (e.target.value === 2) {
    //   this.$set(this.form, 'trademark_type', this.trademark_types[1])
    // }
  }

  async submit() {
    await (this.$refs.modalForm as any).validate()
    this.loading = true
    try {
      const { brand_id } = await api.saveBrand(this.form)
      const list = this.data.brand_list
      if (this.form.id) {
        // 编辑操作
        list.splice(
          list.findIndex((item) => item.id === this.form.id),
          1,
          { ...this.form }
        )
      } else {
        // 新增操作
        list.push({ ...this.form, id: brand_id })
      }
      this.dialogVisible = false
    } catch (err) {
      console.error(err)
    }
    this.loading = false
  }
}
